import { render, staticRenderFns } from "./LiveReport.vue?vue&type=template&id=1b679833&scoped=true"
import script from "./LiveReport.vue?vue&type=script&lang=js"
export * from "./LiveReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b679833",
  null
  
)

export default component.exports